/* Pup Choice cart drawer — intercepts add-to-cart, keeps the free-gift line in sync,
   re-renders via the Section Rendering API (/?sections=pc-cart-drawer). */
(function () {
  'use strict';
  var SECTION = 'pc-cart-drawer';
  var drawer, overlay, inner, lastFocus, busy = false;
  var declinedKey = 'pcGiftDeclined';   /* shopper said "No thanks" this session */
  var offKey = 'pcGiftOff';             /* Shopify did not zero the gift (discount rule missing or a code-discounted cart) */

  function $(sel, root) { return (root || document).querySelector(sel); }
  function cfg() {
    var d = inner.dataset;
    return {
      threshold: parseInt(d.threshold, 10) || 4900,
      giftVariant: d.giftVariant,
      giftKey: d.giftKey || '',
      giftFinal: parseInt(d.giftFinal, 10) || 0,
      qualifying: parseInt(d.qualifying, 10) || 0
    };
  }
  function getJSON(url, opts) {
    return fetch(url, Object.assign({ credentials: 'same-origin' }, opts || {})).then(function (r) { return r.json(); });
  }
  function postJSON(url, body) {
    return getJSON(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
  }
  function declined() { try { return sessionStorage.getItem(declinedKey) === '1'; } catch (e) { return false; } }
  function setDeclined(v) { try { v ? sessionStorage.setItem(declinedKey, '1') : sessionStorage.removeItem(declinedKey); } catch (e) {} }
  function giftOff() { try { return sessionStorage.getItem(offKey) === '1'; } catch (e) { return false; } }
  function setGiftOff(v) {
    try { v ? sessionStorage.setItem(offKey, '1') : sessionStorage.removeItem(offKey); } catch (e) {}
    document.documentElement.classList.toggle('pcd-gift-off', !!v);
  }

  /* Re-render the drawer from the server and reconcile the gift line. Returns a promise. */
  function render() {
    return fetch('/?sections=' + SECTION + '&t=' + Date.now(), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var html = json[SECTION] || '';
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('pcDrawerInner');
        if (!fresh) return;
        inner.replaceWith(fresh);
        inner = fresh;
        updateBubble(parseInt(inner.dataset.itemCount, 10) || 0);
        if (window.Shopify && window.Shopify.PaymentButton && window.Shopify.PaymentButton.init) {
          try { window.Shopify.PaymentButton.init(); } catch (e) {}
        }
      });
  }

  /* Gift rules: add the gift when the qualifying subtotal crosses the threshold, remove it when it drops. */
  function reconcile() {
    var c = cfg();
    var hasGift = !!c.giftKey;
    var qualifies = c.qualifying >= c.threshold;
    if (hasGift && (!qualifies || c.giftFinal > 0)) {
      /* Below threshold, or Shopify did not zero it (discount rule not met): take it out. */
      return postJSON('/cart/change.js', { id: c.giftKey, quantity: 0 }).then(render);
    }
    if (!hasGift && qualifies && !declined() && !giftOff()) {
      return postJSON('/cart/add.js', { items: [{ id: c.giftVariant, quantity: 1, properties: { _pc_gift: '1' } }] })
        .then(render)
        .then(function () {
          var c2 = cfg();
          if (c2.giftKey && c2.giftFinal > 0) {
            /* Discount did not apply (rule missing or code-discounted cart). Remove, switch copy to no-gift, stop retrying this session. */
            setGiftOff(true);
            return postJSON('/cart/change.js', { id: c2.giftKey, quantity: 0 }).then(render);
          }
        });
    }
    return Promise.resolve();
  }

  function sync() { return render().then(reconcile); }

  function updateBubble(count) {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    var b = icon.querySelector('.cart-count');
    if (count > 0) {
      if (!b) { b = document.createElement('span'); b.className = 'cart-count'; icon.appendChild(b); }
      b.textContent = count;
    } else if (b) { b.remove(); }
    icon.setAttribute('aria-label', 'Cart (' + count + ')');
  }

  function open(flash) {
    lastFocus = document.activeElement;
    overlay.classList.add('open');
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('pcd-lock');
    var f = $('#pcDrawerFlash', drawer);
    if (f) { f.hidden = !flash; }
    var close = $('.pcd-close', drawer);
    setTimeout(function () { (close || drawer).focus(); }, 60);
  }
  function close() {
    overlay.classList.remove('open');
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('pcd-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function setBusy(v) { busy = v; drawer.classList.toggle('is-busy', v); }

  function addVariant(id, qty, extra) {
    var item = Object.assign({ id: id, quantity: qty || 1 }, extra || {});
    return postJSON('/cart/add.js', { items: [item] });
  }

  /* Product-form submit → fetch add → open drawer (capture phase so app scripts cannot stop it first) */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    /* form.id is shadowed by the <input name="id"> inside the product form, so read the attribute. */
    if (!form || !form.getAttribute || form.getAttribute('id') !== 'pc-product-form' || form.dataset.pcdFallback === '1') return;
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    var btn = form.querySelector('.atc-btn');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    var fd = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status >= 400) { throw new Error(res.description || 'Could not add'); }
        return sync();
      })
      .then(function () { open(true); })
      .catch(function (err) {
        /* Fetch path failed: fall back to the normal form post so the shopper is never stuck. */
        if (window.console) console.warn('pc-cart-drawer: falling back to form submit', err);
        form.dataset.pcdFallback = '1';
        form.submit();
      })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } setBusy(false); });
  }, true);

  /* Clicks inside the drawer and on the header cart icon */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-pcd-close], #cart-icon-bubble, [data-pcd-add], [data-pcd-gift-add], [data-pcd-qty], [data-pcd-remove], [data-pcd-subscribe]');
    if (!t) return;
    if (t.id === 'cart-icon-bubble') {
      e.preventDefault();
      e.stopPropagation(); /* keep app scripts (Kaktus) from opening their own cart on this click */
      setBusy(true);
      sync().then(function () { open(false); }).finally(function () { setBusy(false); });
      return;
    }
    if (t.hasAttribute('data-pcd-close')) { close(); return; }
    if (busy) return;
    setBusy(true);
    var p;
    if (t.hasAttribute('data-pcd-gift-add')) {
      setDeclined(false);
      t.textContent = 'Adding…';
      p = Promise.resolve(); /* reconcile() adds the gift once declined is cleared */
    } else if (t.hasAttribute('data-pcd-add')) {
      t.textContent = 'Adding…';
      p = addVariant(t.getAttribute('data-pcd-add'), 1);
    } else if (t.hasAttribute('data-pcd-qty')) {
      var line = t.closest('.pcd-line');
      var cur = parseInt(line.querySelector('.pcd-qty span').textContent, 10) || 1;
      var next = Math.max(0, cur + parseInt(t.getAttribute('data-pcd-qty'), 10));
      p = postJSON('/cart/change.js', { id: line.dataset.key, quantity: next });
    } else if (t.hasAttribute('data-pcd-remove')) {
      var key = t.getAttribute('data-pcd-remove');
      if (t.closest('.pcd-line.is-gift')) setDeclined(true);
      p = postJSON('/cart/change.js', { id: key, quantity: 0 });
    } else if (t.hasAttribute('data-pcd-subscribe')) {
      p = postJSON('/cart/change.js', { line: parseInt(t.getAttribute('data-line'), 10), quantity: parseInt(t.closest('.pcd-line').querySelector('.pcd-qty span').textContent, 10) || 1, selling_plan: parseInt(t.getAttribute('data-pcd-subscribe'), 10) });
    }
    p.then(sync).catch(function () { return render(); }).finally(function () { setBusy(false); });
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('open')) close();
  });

  function init() {
    drawer = document.getElementById('pcCartDrawer');
    overlay = document.getElementById('pcDrawerOverlay');
    inner = document.getElementById('pcDrawerInner');
    if (!drawer || !overlay || !inner) return;
    /* Move out of the header section so position:fixed is relative to the viewport, not a transformed ancestor. */
    document.body.appendChild(overlay);
    document.body.appendChild(drawer);
    window.pcCartDrawer = { version: '1.0', open: function () { return sync().then(function () { open(false); }); }, close: close, sync: sync };
    /* A fresh add resets a declined gift so the next qualifying cart offers it again. */
    if ((parseInt(inner.dataset.itemCount, 10) || 0) === 0) { setDeclined(false); setGiftOff(false); }
    if (giftOff()) document.documentElement.classList.add('pcd-gift-off');
    /* Reconcile silently on load in case the cart changed elsewhere (cart page, permalinks). */
    if ((parseInt(inner.dataset.itemCount, 10) || 0) > 0) reconcile();
    if (location.hash === '#cart') { sync().then(function () { open(false); }); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
